export async function getGraphql(graphQlFilePath) {
  const res = await fetch(`/graphql/${graphQlFilePath}`)
  const query = await res.text()
  return query
}
